import { AffectUser } from '@/types/affectUser';
import { Staff } from '@/types/person';

const formatStaffName = ({
  staff,
  byLastName = false
}: {
  staff: Staff | AffectUser;
  byLastName?: boolean;
}): string => {
  const { first_name, last_name } = staff;

  return byLastName ? `${last_name}, ${first_name}` : `${first_name} ${last_name}`;
};

export default formatStaffName;
